import { assets } from "@/lib/assets";
import { Compass, Target } from "lucide-react";

export const MissionVision = () => {
  return (
    <section id="about" data-testid="mission-vision-section" className="relative py-24 md:py-32">
      <div className="kat-container">
        <div className="max-w-3xl">
          <p className="overline">Our Purpose</p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[color:var(--kat-navy)]">
            A firm built to help people, businesses, and communities move forward — together.
          </h2>
        </div>

        <div className="mt-16 md:mt-20 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: Mission + Vision cards */}
          <div className="lg:col-span-7 grid md:grid-cols-2 gap-6 md:gap-8">
            <article
              data-testid="mission-card"
              className="group relative border border-slate-200 bg-white p-8 md:p-10 rounded-sm transition-all duration-500 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-11 h-11 rounded-sm border border-[color:var(--kat-navy)] flex items-center justify-center text-[color:var(--kat-navy)]">
                  <Target size={18} strokeWidth={1.5} />
                </div>
                <p className="overline">Mission</p>
              </div>
              <p className="font-serif text-2xl leading-snug text-[color:var(--kat-navy)]">
                To empower entrepreneurs, small businesses, and communities through
                professional consulting, workforce development training, bookkeeping
                solutions, and innovative property management services that generate
                sustainable economic growth.
              </p>
            </article>

            <article
              data-testid="vision-card"
              className="group relative bg-[color:var(--kat-navy)] text-white p-8 md:p-10 rounded-sm transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl grain"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-11 h-11 rounded-sm border border-[color:var(--kat-sky)] flex items-center justify-center text-[color:var(--kat-sky)]">
                  <Compass size={18} strokeWidth={1.5} />
                </div>
                <p className="text-[11px] tracking-[0.28em] uppercase font-semibold text-[color:var(--kat-sky)]">
                  Vision
                </p>
              </div>
              <p className="font-serif text-2xl leading-snug text-white/95">
                To become a leading minority-owned consulting and business services
                company — supporting small business success while building a portfolio
                of income-producing short-term rental properties that drive local
                economic development and employment.
              </p>
            </article>
          </div>

          {/* Right: image with quote */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:ml-auto">
              <img
                src={assets.bookkatLearning}
                alt="Karlene A Thomas, BSc. leading a BOOKKAT professional development session"
                data-testid="mission-founder-image"
                className="w-full h-full object-cover rounded-sm shadow-xl"
              />
              <div className="absolute -bottom-6 -left-6 md:-left-10 bg-white border border-slate-200 shadow-lg px-6 py-5 rounded-sm max-w-[260px]">
                <p className="font-serif italic text-lg text-[color:var(--kat-navy)] leading-snug">
                  “We help institutions lead with clarity and grow with intention.”
                </p>
                <p className="mt-3 text-xs tracking-[0.22em] uppercase font-semibold text-[color:var(--kat-muted)]">
                  — Karlene A Thomas, BSc., Founder
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
